import { CloseIcon, SearchIcon } from '@dynamika-shared/ui/icons';
import { Input } from 'antd';
import { useEffect , FC } from 'react';
import { useParams } from 'react-router-dom';
import { useValidationSpecialistSubjectsSlice } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.slice';
import { useSubjectListFilters } from './useSubjectListFilters';

export const SubjectListFilters: FC = () => {
  const { onSearch } = useSubjectListFilters();
  const [searchValue, setSearchValue] = useValidationSpecialistSubjectsSlice((state, actions) => [
    state.search,
    actions.setSearchValue,
  ]);
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();
  
  useEffect(() => {
    setSearchValue('');
    onSearch('');
  }, [clinicalTrialId]);

  return (
    <div className='flex flex-wrap justify-end'>
      <div className='flex items-center gap-3 pb-[20px]'>
        <Input
          placeholder='Search'
          className='min-w-[400px] max-w-lg rounded-[32px] px-2 py-[10px] text-1424 text-spanishGray'
          suffix={
            searchValue.length ? (
              <CloseIcon
                className='h-2.5 w-2.5 cursor-pointer font-medium'
                onClick={() => {
                  setSearchValue('');
                  onSearch('');
                }}
              />
            ) : (
              <SearchIcon className='h-2 w-2 cursor-pointer' />
            )
          }
          value={searchValue}
          onChange={({ target: { value } }) => {
            setSearchValue(value);
            onSearch(value);
          }}
        />
      </div>
    </div>
  );
};
